// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class TermsOfServiceResource extends Resource {
    basePath: string = 'web/terms/';

    objectPath: string = 'web/terms/{ident}/';
}
